export const ArrowDown = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="12" viewBox="0 0 20 12" fill="none">
      <path
        d="M1.7394 1.43553L1.73938 1.43555L1.7422 1.4383L9.7672 9.2758L10.0012 9.50434L10.2341 9.27469L18.2591 1.3622L18.2608 1.36053C18.4681 1.15321 18.7821 1.15321 18.9894 1.36053C19.1964 1.56756 19.1967 1.8809 18.9903 2.08823C18.99 2.08853 18.9897 2.08883 18.9894 2.08913L10.3665 10.5621L10.3665 10.5621L10.3644 10.5641C10.2056 10.7229 10.0982 10.7665 10.0001 10.7665C9.86699 10.7665 9.75391 10.7278 9.62082 10.6244L1.0108 2.16413C1.01049 2.16382 1.01019 2.16352 1.00989 2.16321C0.803475 1.95588 0.80378 1.64255 1.0108 1.43553C1.21813 1.22821 1.53207 1.22821 1.7394 1.43553Z"
        fill="#8899A8"
        stroke="#8899A8"
        strokeWidth="0.666667"
      />
    </svg>
  );
};
